webpackJsonp([16],{

/***/ "+8Tv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__("7UJR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_resource__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource___default.a);

var SidebarService = function () {
  function SidebarService(endpoint) {
    _classCallCheck(this, SidebarService);

    if (!SidebarService.singleton) {
      this.endpoint = endpoint;

      SidebarService.singleton = this;
    }

    return SidebarService.singleton;
  }

  _createClass(SidebarService, [{
    key: 'get',
    value: function get() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(this.endpoint);
    }
  }, {
    key: 'update',
    value: function update(key, data) {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.put(this.endpoint, _defineProperty({}, key, data), {
        emulateJSON: true
      });
    }
  }]);

  return SidebarService;
}();

/* harmony default export */ __webpack_exports__["a"] = (SidebarService);

/***/ }),

/***/ "/2HX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__help_state__ = __webpack_require__("UQR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__collapsed_state__ = __webpack_require__("1cXH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spent_only_pane__ = __webpack_require__("Knbu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__no_tracking_pane__ = __webpack_require__("Xvs4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__estimate_only_pane__ = __webpack_require__("Yqnm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__comparison_pane__ = __webpack_require__("lMh4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__event_hub__ = __webpack_require__("9aVq");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'issuable-time-tracker',
  props: {
    time_estimate: {
      type: Number,
      required: true
    },
    time_spent: {
      type: Number,
      required: true
    },
    human_time_estimate: {
      type: String,
      required: false,
      default: ''
    },
    human_time_spent: {
      type: String,
      required: false,
      default: ''
    },
    rootPath: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      showHelp: false
    };
  },

  components: {
    'time-tracking-collapsed-state': __WEBPACK_IMPORTED_MODULE_1__collapsed_state__["a" /* default */],
    'time-tracking-estimate-only-pane': __WEBPACK_IMPORTED_MODULE_4__estimate_only_pane__["a" /* default */],
    'time-tracking-spent-only-pane': __WEBPACK_IMPORTED_MODULE_2__spent_only_pane__["a" /* default */],
    'time-tracking-no-tracking-pane': __WEBPACK_IMPORTED_MODULE_3__no_tracking_pane__["a" /* default */],
    'time-tracking-comparison-pane': __WEBPACK_IMPORTED_MODULE_5__comparison_pane__["a" /* default */],
    'time-tracking-help-state': __WEBPACK_IMPORTED_MODULE_0__help_state__["a" /* default */]
  },
  computed: {
    timeSpent: function timeSpent() {
      return this.time_spent;
    },
    timeEstimate: function timeEstimate() {
      return this.time_estimate;
    },
    timeEstimateHumanReadable: function timeEstimateHumanReadable() {
      return this.human_time_estimate;
    },
    timeSpentHumanReadable: function timeSpentHumanReadable() {
      return this.human_time_spent;
    },
    hasTimeSpent: function hasTimeSpent() {
      return !!this.timeSpent;
    },
    hasTimeEstimate: function hasTimeEstimate() {
      return !!this.timeEstimate;
    },
    showComparisonState: function showComparisonState() {
      return this.hasTimeEstimate && this.hasTimeSpent;
    },
    showEstimateOnlyState: function showEstimateOnlyState() {
      return this.hasTimeEstimate && !this.hasTimeSpent;
    },
    showSpentOnlyState: function showSpentOnlyState() {
      return this.hasTimeSpent && !this.hasTimeEstimate;
    },
    showNoTimeTrackingState: function showNoTimeTrackingState() {
      return !this.hasTimeEstimate && !this.hasTimeSpent;
    },
    showHelpState: function showHelpState() {
      return !!this.showHelp;
    }
  },
  methods: {
    toggleHelpState: function toggleHelpState(show) {
      this.showHelp = show;
    },
    update: function update(data) {
      this.time_estimate = data.time_estimate;
      this.time_spent = data.time_spent;
      this.human_time_estimate = data.human_time_estimate;
      this.human_time_spent = data.human_time_spent;
    }
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_6__event_hub__["a" /* default */].$on('timeTracker:updateData', this.update);
  },

  template: '\n    <div\n      class="time_tracker time-tracking-component-wrap"\n      v-cloak\n    >\n      <time-tracking-collapsed-state\n        :show-comparison-state="showComparisonState"\n        :show-no-time-tracking-state="showNoTimeTrackingState"\n        :show-help-state="showHelpState"\n        :show-spent-only-state="showSpentOnlyState"\n        :show-estimate-only-state="showEstimateOnlyState"\n        :time-spent-human-readable="timeSpentHumanReadable"\n        :time-estimate-human-readable="timeEstimateHumanReadable"\n      />\n      <div class="title hide-collapsed">\n        Time tracking\n        <div\n          class="help-button pull-right"\n          v-if="!showHelpState"\n          @click="toggleHelpState(true)"\n        >\n            <i\n              class="fa fa-question-circle"\n              aria-hidden="true"\n            />\n        </div>\n        <div\n          class="close-help-button pull-right"\n          v-if="showHelpState"\n          @click="toggleHelpState(false)"\n        >\n          <i\n            class="fa fa-close"\n            aria-hidden="true"\n          />\n        </div>\n      </div>\n      <div class="time-tracking-content hide-collapsed">\n        <time-tracking-estimate-only-pane\n          v-if="showEstimateOnlyState"\n          :time-estimate-human-readable="timeEstimateHumanReadable"\n        />\n        <time-tracking-spent-only-pane\n          v-if="showSpentOnlyState"\n          :time-spent-human-readable="timeSpentHumanReadable"\n        />\n        <time-tracking-no-tracking-pane\n          v-if="showNoTimeTrackingState"\n        />\n        <time-tracking-comparison-pane\n          v-if="showComparisonState"\n          :time-estimate="timeEstimate"\n          :time-spent="timeSpent"\n          :time-spent-human-readable="timeSpentHumanReadable"\n          :time-estimate-human-readable="timeEstimateHumanReadable"\n        />\n        <transition name="help-state-toggle">\n          <time-tracking-help-state\n            v-if="showHelpState"\n            :rootPath="rootPath"\n          />\n        </transition>\n      </div>\n    </div>\n  '
});

/***/ }),

/***/ "1cXH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icons_icon_stopwatch_svg__ = __webpack_require__("2P/j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_icons_icon_stopwatch_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_icons_icon_stopwatch_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_pretty_time__ = __webpack_require__("I8f0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_pretty_time___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lib_utils_pretty_time__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'time-tracking-collapsed-state',
  props: {
    showComparisonState: {
      type: Boolean,
      required: true
    },
    showSpentOnlyState: {
      type: Boolean,
      required: true
    },
    showEstimateOnlyState: {
      type: Boolean,
      required: true
    },
    showNoTimeTrackingState: {
      type: Boolean,
      required: true
    },
    timeSpentHumanReadable: {
      type: String,
      required: false,
      default: ''
    },
    timeEstimateHumanReadable: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    timeSpent: function timeSpent() {
      return this.abbreviateTime(this.timeSpentHumanReadable);
    },
    timeEstimate: function timeEstimate() {
      return this.abbreviateTime(this.timeEstimateHumanReadable);
    },
    divClass: function divClass() {
      if (this.showComparisonState) {
        return 'compare';
      } else if (this.showEstimateOnlyState) {
        return 'estimate-only';
      } else if (this.showSpentOnlyState) {
        return 'spend-only';
      } else if (this.showNoTimeTrackingState) {
        return 'no-tracking';
      }

      return '';
    },
    spanClass: function spanClass() {
      if (this.showComparisonState) {
        return '';
      } else if (this.showEstimateOnlyState || this.showSpentOnlyState) {
        return 'bold';
      } else if (this.showNoTimeTrackingState) {
        return 'no-value';
      }

      return '';
    },
    text: function text() {
      if (this.showComparisonState) {
        return this.timeSpent + ' / ' + this.timeEstimate;
      } else if (this.showEstimateOnlyState) {
        return '-- / ' + this.timeEstimate;
      } else if (this.showSpentOnlyState) {
        return this.timeSpent + ' / --';
      } else if (this.showNoTimeTrackingState) {
        return 'None';
      }

      return '';
    }
  },
  methods: {
    abbreviateTime: function abbreviateTime(timeStr) {
      return gl.utils.prettyTime.abbreviateTime(timeStr);
    }
  },
  template: '\n    <div class="sidebar-collapsed-icon">\n      ' + __WEBPACK_IMPORTED_MODULE_0_icons_icon_stopwatch_svg___default.a + '\n      <div class="time-tracking-collapsed-summary">\n        <div :class="divClass">\n          <span :class="spanClass">\n            {{ text }}\n          </span>\n        </div>\n      </div>\n    </div>\n    '
});

/***/ }),

/***/ "2P/j":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 14\" enable-background=\"new 0 0 12 14\"><path d=\"m11.5 2.4l-1.3-1.1-1 1.1 1.4 1.1.9-1.1\"/><path d=\"m6.8 2v-.5h.5v-1.5h-2.6v1.5h.5v.5c-2.9.4-5.2 2.9-5.2 6 0 3.3 2.7 6 6 6s6-2.7 6-6c0-3-2.3-5.6-5.2-6m-.8 10.5c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5 4.5 2 4.5 4.5-2 4.5-4.5 4.5\"/><path d=\"m6.2 8.9h-.5c-.1 0-.2-.1-.2-.2v-3.5c0-.1.1-.2.2-.2h.5c.1 0 .2.1.2.2v3.5c0 .1-.1.2-.2.2\"/></svg>\n"

/***/ }),

/***/ "3x6e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_time_tracking_sidebar_time_tracking__ = __webpack_require__("X9pJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_assignees_sidebar_assignees__ = __webpack_require__("AobQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sidebar_mediator__ = __webpack_require__("ywr0");






function domContentLoaded() {
  var mediator = new __WEBPACK_IMPORTED_MODULE_3__sidebar_mediator__["a" /* default */](gl.sidebarOptions);
  mediator.fetch();

  var sidebarAssigneesEl = document.querySelector('#js-vue-sidebar-assignees');

  // Only create the sidebarAssignees vue app if it is found in the DOM
  // We currently do not use sidebarAssignees for the MR page
  if (sidebarAssigneesEl) {
    new __WEBPACK_IMPORTED_MODULE_0_vue__["default"](__WEBPACK_IMPORTED_MODULE_2__components_assignees_sidebar_assignees__["a" /* default */]).$mount(sidebarAssigneesEl);
  }

  new __WEBPACK_IMPORTED_MODULE_0_vue__["default"](__WEBPACK_IMPORTED_MODULE_1__components_time_tracking_sidebar_time_tracking__["a" /* default */]).$mount('#issuable-time-tracker');
}

document.addEventListener('DOMContentLoaded', domContentLoaded);

/* harmony default export */ __webpack_exports__["default"] = (domContentLoaded);

/***/ }),

/***/ "9aVq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("JTVE");


var eventHub = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

// TODO: remove eventHub hack after code splitting refactor
window.emitSidebarEvent = function () {
  return eventHub.$emit.apply(eventHub, arguments);
};

/* harmony default export */ __webpack_exports__["a"] = (eventHub);

/***/ }),

/***/ "AobQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignee_title__ = __webpack_require__("DrL9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assignees__ = __webpack_require__("ypBK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_sidebar_store__ = __webpack_require__("Y2qp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sidebar_mediator__ = __webpack_require__("ywr0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_hub__ = __webpack_require__("9aVq");
/* global Flash */









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SidebarAssignees',
  data: function data() {
    return {
      mediator: new __WEBPACK_IMPORTED_MODULE_3__sidebar_mediator__["a" /* default */](),
      store: new __WEBPACK_IMPORTED_MODULE_2__stores_sidebar_store__["a" /* default */](),
      loading: false,
      field: ''
    };
  },

  components: {
    'assignee-title': __WEBPACK_IMPORTED_MODULE_0__assignee_title__["a" /* default */],
    assignees: __WEBPACK_IMPORTED_MODULE_1__assignees__["a" /* default */]
  },
  methods: {
    assignSelf: function assignSelf() {
      // Notify gl dropdown that we are now assigning to current user
      this.$el.parentElement.dispatchEvent(new Event('assignYourself'));

      this.mediator.assignYourself();
      this.saveAssignees();
    },
    saveAssignees: function saveAssignees() {
      this.loading = true;

      function setLoadingFalse() {
        this.loading = false;
      }

      this.mediator.saveAssignees(this.field).then(setLoadingFalse.bind(this)).catch(function () {
        setLoadingFalse();
        return new Flash('Error occurred when saving assignees');
      });
    }
  },
  created: function created() {
    this.removeAssignee = this.store.removeAssignee.bind(this.store);
    this.addAssignee = this.store.addAssignee.bind(this.store);
    this.removeAllAssignees = this.store.removeAllAssignees.bind(this.store);

    // Get events from glDropdown
    __WEBPACK_IMPORTED_MODULE_4__event_hub__["a" /* default */].$on('sidebar.removeAssignee', this.removeAssignee);
    __WEBPACK_IMPORTED_MODULE_4__event_hub__["a" /* default */].$on('sidebar.addAssignee', this.addAssignee);
    __WEBPACK_IMPORTED_MODULE_4__event_hub__["a" /* default */].$on('sidebar.removeAllAssignees', this.removeAllAssignees);
    __WEBPACK_IMPORTED_MODULE_4__event_hub__["a" /* default */].$on('sidebar.saveAssignees', this.saveAssignees);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_4__event_hub__["a" /* default */].$off('sidebar.removeAssignee', this.removeAssignee);
    __WEBPACK_IMPORTED_MODULE_4__event_hub__["a" /* default */].$off('sidebar.addAssignee', this.addAssignee);
    __WEBPACK_IMPORTED_MODULE_4__event_hub__["a" /* default */].$off('sidebar.removeAllAssignees', this.removeAllAssignees);
    __WEBPACK_IMPORTED_MODULE_4__event_hub__["a" /* default */].$off('sidebar.saveAssignees', this.saveAssignees);
  },
  beforeMount: function beforeMount() {
    this.field = this.$el.dataset.field;
  },

  template: '\n    <div>\n      <assignee-title\n        :number-of-assignees="store.assignees.length"\n        :loading="loading"\n        :editable="store.editable"\n      />\n      <assignees\n        class="value"\n        :root-path="store.rootPath"\n        :users="store.assignees"\n        :editable="store.editable"\n        @assign-self="assignSelf"\n      />\n    </div>\n  '
});

/***/ }),

/***/ "DrL9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AssigneeTitle',
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    numberOfAssignees: {
      type: Number,
      required: true
    },
    editable: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    assigneeTitle: function assigneeTitle() {
      var assignees = this.numberOfAssignees;
      return assignees > 1 ? assignees + ' Assignees' : 'Assignee';
    }
  },
  template: '\n    <div class="title hide-collapsed">\n      {{assigneeTitle}}\n      <i\n        v-if="loading"\n        aria-hidden="true"\n        class="fa fa-spinner fa-spin block-loading"\n      />\n      <a\n        v-if="editable"\n        class="edit-link pull-right"\n        href="#"\n      >\n        Edit\n      </a>\n    </div>\n  '
});

/***/ }),

/***/ "Knbu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'time-tracking-spent-only-pane',
  props: {
    timeSpentHumanReadable: {
      type: String,
      required: true
    }
  },
  template: '\n    <div class="time-tracking-spend-only-pane">\n      <span class="bold">Spent:</span>\n      {{ timeSpentHumanReadable }}\n    </div>\n  '
});

/***/ }),

/***/ "UQR6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'time-tracking-help-state',
  props: {
    rootPath: {
      type: String,
      required: true
    }
  },
  computed: {
    href: function href() {
      return this.rootPath + 'help/workflow/time_tracking.md';
    }
  },
  template: '\n    <div class="time-tracking-help-state">\n      <div class="time-tracking-info">\n        <h4>\n          Track time with slash commands\n        </h4>\n        <p>\n          Slash commands can be used in the issues description and comment boxes.\n        </p>\n        <p>\n          <code>\n            /estimate\n          </code>\n          will update the estimated time with the latest command.\n        </p>\n        <p>\n          <code>\n            /spend\n          </code>\n          will update the sum of the time spent.\n        </p>\n        <a\n          class="btn btn-default learn-more-button"\n          :href="href"\n        >\n          Learn more\n        </a>\n      </div>\n    </div>\n  '
});

/***/ }),

/***/ "X9pJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__smart_interval__ = __webpack_require__("EQHa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__smart_interval___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__smart_interval__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__time_tracker__ = __webpack_require__("/2HX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_sidebar_store__ = __webpack_require__("Y2qp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sidebar_mediator__ = __webpack_require__("ywr0");







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      mediator: new __WEBPACK_IMPORTED_MODULE_3__sidebar_mediator__["a" /* default */](),
      store: new __WEBPACK_IMPORTED_MODULE_2__stores_sidebar_store__["a" /* default */]()
    };
  },

  components: {
    'issuable-time-tracker': __WEBPACK_IMPORTED_MODULE_1__time_tracker__["a" /* default */]
  },
  methods: {
    listenForSlashCommands: function listenForSlashCommands() {
      $(document).on('ajax:success', '.gfm-form', this.slashCommandListened);
    },
    slashCommandListened: function slashCommandListened(e, data) {
      var subscribedCommands = ['spend_time', 'time_estimate'];
      var changedCommands = void 0;
      if (data !== undefined) {
        changedCommands = data.commands_changes ? Object.keys(data.commands_changes) : [];
      } else {
        changedCommands = [];
      }
      if (changedCommands && _.intersection(subscribedCommands, changedCommands).length) {
        this.mediator.fetch();
      }
    }
  },
  mounted: function mounted() {
    this.listenForSlashCommands();
  },

  template: '\n    <div class="block">\n      <issuable-time-tracker\n        :time_estimate="store.timeEstimate"\n        :time_spent="store.totalTimeSpent"\n        :human_time_estimate="store.humanTimeEstimate"\n        :human_time_spent="store.humanTotalTimeSpent"\n        :rootPath="store.rootPath"\n      />\n    </div>\n  '
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "Xvs4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'time-tracking-no-tracking-pane',
  template: '\n    <div class="time-tracking-no-tracking-pane">\n      <span class="no-value">\n        No estimate or time spent\n      </span>\n    </div>\n  '
});

/***/ }),

/***/ "Y2qp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SidebarStore = function () {
  function SidebarStore(store) {
    _classCallCheck(this, SidebarStore);

    if (!SidebarStore.singleton) {
      var currentUser = store.currentUser,
          rootPath = store.rootPath,
          editable = store.editable;

      this.currentUser = currentUser;
      this.rootPath = rootPath;
      this.editable = editable;
      this.timeEstimate = 0;
      this.totalTimeSpent = 0;
      this.humanTimeEstimate = '';
      this.humanTimeSpent = '';
      this.assignees = [];

      SidebarStore.singleton = this;
    }

    return SidebarStore.singleton;
  }

  _createClass(SidebarStore, [{
    key: 'setAssigneeData',
    value: function setAssigneeData(data) {
      if (data.assignees) {
        this.assignees = data.assignees;
      }
    }
  }, {
    key: 'setTimeTrackingData',
    value: function setTimeTrackingData(data) {
      this.timeEstimate = data.time_estimate;
      this.totalTimeSpent = data.total_time_spent;
      this.humanTimeEstimate = data.human_time_estimate;
      this.humanTotalTimeSpent = data.human_total_time_spent;
    }
  }, {
    key: 'addAssignee',
    value: function addAssignee(assignee) {
      if (!this.findAssignee(assignee)) {
        this.assignees.push(assignee);
      }
    }
  }, {
    key: 'findAssignee',
    value: function findAssignee(_findAssignee) {
      return this.assignees.filter(function (assignee) {
        return assignee.id === _findAssignee.id;
      })[0];
    }
  }, {
    key: 'removeAssignee',
    value: function removeAssignee(_removeAssignee) {
      if (_removeAssignee) {
        this.assignees = this.assignees.filter(function (assignee) {
          return assignee.id !== _removeAssignee.id;
        });
      }
    }
  }, {
    key: 'removeAllAssignees',
    value: function removeAllAssignees() {
      this.assignees = [];
    }
  }]);

  return SidebarStore;
}();

/* harmony default export */ __webpack_exports__["a"] = (SidebarStore);

/***/ }),

/***/ "Yqnm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'time-tracking-estimate-only-pane',
  props: {
    timeEstimateHumanReadable: {
      type: String,
      required: true
    }
  },
  template: '\n    <div class="time-tracking-estimate-only-pane">\n      <span class="bold">\n        Estimated:\n      </span>\n      {{ timeEstimateHumanReadable }}\n    </div>\n  '
});

/***/ }),

/***/ "lMh4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_pretty_time__ = __webpack_require__("I8f0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_pretty_time___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lib_utils_pretty_time__);


var prettyTime = gl.utils.prettyTime;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'time-tracking-comparison-pane',
  props: {
    timeSpent: {
      type: Number,
      required: true
    },
    timeEstimate: {
      type: Number,
      required: true
    },
    timeSpentHumanReadable: {
      type: String,
      required: true
    },
    timeEstimateHumanReadable: {
      type: String,
      required: true
    }
  },
  computed: {
    parsedRemaining: function parsedRemaining() {
      var diffSeconds = this.timeEstimate - this.timeSpent;
      return prettyTime.parseSeconds(diffSeconds);
    },
    timeRemainingHumanReadable: function timeRemainingHumanReadable() {
      return prettyTime.stringifyTime(this.parsedRemaining);
    },
    timeRemainingTooltip: function timeRemainingTooltip() {
      var prefix = this.timeRemainingMinutes < 0 ? 'Over by' : 'Time remaining:';
      return prefix + ' ' + this.timeRemainingHumanReadable;
    },

    /* Diff values for comparison meter */
    timeRemainingMinutes: function timeRemainingMinutes() {
      return this.timeEstimate - this.timeSpent;
    },
    timeRemainingPercent: function timeRemainingPercent() {
      return Math.floor(this.timeSpent / this.timeEstimate * 100) + '%';
    },
    timeRemainingStatusClass: function timeRemainingStatusClass() {
      return this.timeEstimate >= this.timeSpent ? 'within_estimate' : 'over_estimate';
    },

    /* Parsed time values */
    parsedEstimate: function parsedEstimate() {
      return prettyTime.parseSeconds(this.timeEstimate);
    },
    parsedSpent: function parsedSpent() {
      return prettyTime.parseSeconds(this.timeSpent);
    }
  },
  template: '\n    <div class="time-tracking-comparison-pane">\n      <div\n        class="compare-meter"\n        data-toggle="tooltip"\n        data-placement="top"\n        role="timeRemainingDisplay"\n        :aria-valuenow="timeRemainingTooltip"\n        :title="timeRemainingTooltip"\n        :data-original-title="timeRemainingTooltip"\n        :class="timeRemainingStatusClass"\n      >\n        <div\n          class="meter-container"\n          role="timeSpentPercent"\n          :aria-valuenow="timeRemainingPercent"\n        >\n          <div\n            :style="{ width: timeRemainingPercent }"\n            class="meter-fill"\n          />\n        </div>\n        <div class="compare-display-container">\n          <div class="compare-display pull-left">\n            <span class="compare-label">\n              Spent\n            </span>\n            <span class="compare-value spent">\n              {{ timeSpentHumanReadable }}\n            </span>\n          </div>\n          <div class="compare-display estimated pull-right">\n            <span class="compare-label">\n              Est\n            </span>\n            <span class="compare-value">\n              {{ timeEstimateHumanReadable }}\n            </span>\n          </div>\n        </div>\n      </div>\n    </div>\n  '
});

/***/ }),

/***/ "ypBK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Assignees',
  data: function data() {
    return {
      defaultRenderCount: 5,
      defaultMaxCounter: 99,
      showLess: true
    };
  },

  props: {
    rootPath: {
      type: String,
      required: true
    },
    users: {
      type: Array,
      required: true
    },
    editable: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    firstUser: function firstUser() {
      return this.users[0];
    },
    hasMoreThanTwoAssignees: function hasMoreThanTwoAssignees() {
      return this.users.length > 2;
    },
    hasMoreThanOneAssignee: function hasMoreThanOneAssignee() {
      return this.users.length > 1;
    },
    hasAssignees: function hasAssignees() {
      return this.users.length > 0;
    },
    hasNoUsers: function hasNoUsers() {
      return !this.users.length;
    },
    hasOneUser: function hasOneUser() {
      return this.users.length === 1;
    },
    renderShowMoreSection: function renderShowMoreSection() {
      return this.users.length > this.defaultRenderCount;
    },
    numberOfHiddenAssignees: function numberOfHiddenAssignees() {
      return this.users.length - this.defaultRenderCount;
    },
    isHiddenAssignees: function isHiddenAssignees() {
      return this.numberOfHiddenAssignees > 0;
    },
    hiddenAssigneesLabel: function hiddenAssigneesLabel() {
      return '+ ' + this.numberOfHiddenAssignees + ' more';
    },
    collapsedTooltipTitle: function collapsedTooltipTitle() {
      var maxRender = Math.min(this.defaultRenderCount, this.users.length);
      var renderUsers = this.users.slice(0, maxRender);
      var names = renderUsers.map(function (u) {
        return u.name;
      });

      if (this.users.length > maxRender) {
        names.push('+ ' + (this.users.length - maxRender) + ' more');
      }

      return names.join(', ');
    },
    sidebarAvatarCounter: function sidebarAvatarCounter() {
      var counter = '+' + (this.users.length - 1);

      if (this.users.length > this.defaultMaxCounter) {
        counter = this.defaultMaxCounter + '+';
      }

      return counter;
    }
  },
  methods: {
    assignSelf: function assignSelf() {
      this.$emit('assign-self');
    },
    toggleShowLess: function toggleShowLess() {
      this.showLess = !this.showLess;
    },
    renderAssignee: function renderAssignee(index) {
      return !this.showLess || index < this.defaultRenderCount && this.showLess;
    },
    avatarUrl: function avatarUrl(user) {
      return user.avatar || user.avatar_url;
    },
    assigneeUrl: function assigneeUrl(user) {
      return '' + this.rootPath + user.username;
    },
    assigneeAlt: function assigneeAlt(user) {
      return user.name + '\'s avatar';
    },
    assigneeUsername: function assigneeUsername(user) {
      return '@' + user.username;
    },
    shouldRenderCollapsedAssignee: function shouldRenderCollapsedAssignee(index) {
      var firstTwo = this.users.length <= 2 && index <= 2;

      return index === 0 || firstTwo;
    }
  },
  template: '\n    <div>\n      <div\n        class="sidebar-collapsed-icon sidebar-collapsed-user"\n        :class="{ \'multiple-users\': hasMoreThanOneAssignee, \'has-tooltip\': hasAssignees }"\n        data-container="body"\n        data-placement="left"\n        :title="collapsedTooltipTitle"\n      >\n        <i\n          v-if="hasNoUsers"\n          aria-label="No Assignee"\n          class="fa fa-user"\n        />\n        <button\n          type="button"\n          class="btn-link"\n          v-for="(user, index) in users"\n          v-if="shouldRenderCollapsedAssignee(index)"\n        >\n          <img\n            width="24"\n            class="avatar avatar-inline s24"\n            :alt="assigneeAlt(user)"\n            :src="avatarUrl(user)"\n          />\n          <span class="author">\n            {{ user.name }}\n          </span>\n        </button>\n        <button\n          v-if="hasMoreThanTwoAssignees"\n          class="btn-link"\n          type="button"\n        >\n          <span\n            class="avatar-counter sidebar-avatar-counter"\n          >\n            {{ sidebarAvatarCounter }}\n          </span>\n        </button>\n      </div>\n      <div class="value hide-collapsed">\n        <template v-if="hasNoUsers">\n          <span class="assign-yourself no-value">\n            No assignee\n            <template v-if="editable">\n             -\n              <button\n                type="button"\n                class="btn-link"\n                @click="assignSelf"\n              >\n                assign yourself\n              </button>\n            </template>\n          </span>\n        </template>\n        <template v-else-if="hasOneUser">\n          <a\n            class="author_link bold"\n            :href="assigneeUrl(firstUser)"\n          >\n            <img\n              width="32"\n              class="avatar avatar-inline s32"\n              :alt="assigneeAlt(firstUser)"\n              :src="avatarUrl(firstUser)"\n            />\n            <span class="author">\n              {{ firstUser.name }}\n            </span>\n            <span class="username">\n              {{ assigneeUsername(firstUser) }}\n            </span>\n          </a>\n        </template>\n        <template v-else>\n          <div class="user-list">\n            <div\n              class="user-item"\n              v-for="(user, index) in users"\n              v-if="renderAssignee(index)"\n            >\n              <a\n                class="user-link has-tooltip"\n                data-placement="bottom"\n                :href="assigneeUrl(user)"\n                :data-title="user.name"\n              >\n                <img\n                  width="32"\n                  class="avatar avatar-inline s32"\n                  :alt="assigneeAlt(user)"\n                  :src="avatarUrl(user)"\n                />\n              </a>\n            </div>\n          </div>\n          <div\n            v-if="renderShowMoreSection"\n            class="user-list-more"\n          >\n            <button\n              type="button"\n              class="btn-link"\n              @click="toggleShowLess"\n            >\n              <template v-if="showLess">\n                {{ hiddenAssigneesLabel }}\n              </template>\n              <template v-else>\n                - show less\n              </template>\n            </button>\n          </div>\n        </template>\n      </div>\n    </div>\n  '
});

/***/ }),

/***/ "ywr0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_sidebar_service__ = __webpack_require__("+8Tv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stores_sidebar_store__ = __webpack_require__("Y2qp");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global Flash */




var SidebarMediator = function () {
  function SidebarMediator(options) {
    _classCallCheck(this, SidebarMediator);

    if (!SidebarMediator.singleton) {
      this.store = new __WEBPACK_IMPORTED_MODULE_1__stores_sidebar_store__["a" /* default */](options);
      this.service = new __WEBPACK_IMPORTED_MODULE_0__services_sidebar_service__["a" /* default */](options.endpoint);
      SidebarMediator.singleton = this;
    }

    return SidebarMediator.singleton;
  }

  _createClass(SidebarMediator, [{
    key: 'assignYourself',
    value: function assignYourself() {
      this.store.addAssignee(this.store.currentUser);
    }
  }, {
    key: 'saveAssignees',
    value: function saveAssignees(field) {
      var selected = this.store.assignees.map(function (u) {
        return u.id;
      });

      // If there are no ids, that means we have to unassign (which is id = 0)
      // And it only accepts an array, hence [0]
      return this.service.update(field, selected.length === 0 ? [0] : selected);
    }
  }, {
    key: 'fetch',
    value: function fetch() {
      var _this = this;

      this.service.get().then(function (response) {
        var data = response.json();
        _this.store.setAssigneeData(data);
        _this.store.setTimeTrackingData(data);
      }).catch(function () {
        return new Flash('Error occured when fetching sidebar data');
      });
    }
  }]);

  return SidebarMediator;
}();

/* harmony default export */ __webpack_exports__["a"] = (SidebarMediator);

/***/ })

},["3x6e"]);


// WEBPACK FOOTER //
// sidebar.db8394fb946d3e5aadbc.bundle.js